import BranchListingView from '@/views/admin/branches/BranchsListingView.vue';
import BranchCreateView from '@/views/admin/branches/BranchCreateView.vue';
import BranchDetailView from '@/views/admin/branches/BranchDetailView.vue';
import BranchYearEditView from '@/views/admin/branches/BranchYearEditView.vue';

export const adminBranchRoutes = [
  {
    path: '/admin/branches',
    name: 'AdminBranchListing',
    component: BranchListingView,
    meta: { guest: false },
  },
  {
    path: '/admin/branch/:branchId/edit',
    name: 'AdminBranchEdit',
    component: BranchDetailView,
    meta: { guest: false },
  },
  {
    path: '/admin/branch/create',
    name: 'AdminBranchCreate',
    component: BranchCreateView,
    meta: { guest: false },
  },
  {
    path: '/admin/branch/:branchId/year/:yearId/:tabName?',
    name: 'AdminBranchYearEdit',
    component: BranchYearEditView,
    meta: { guest: false },
  },
];
